export default "__VITE_ASSET__a701d0bf__"